<template>
    <div>
        <h3 id="order_review_heading">Order Summary</h3>
        <table class="table shop_table order_summary_alignment_fix checkout checkout_custom">
            <thead>
            <tr>
                <th class="product-thumbnail">&nbsp;</th>
                <th class="product-name">Product</th>
                <th class="product-price">Price</th>
                <th class="product-units">Units</th>
                <th class="product-quantity">Quantity</th>
                <th class="product-subtotal">Subtotal</th>
            </tr>
            </thead>
            <tbody>

            <tr class="cart_item" v-for="item in $store.getters.cartItems">
                <td class="product-thumbnail">
                    <a :href="item.publish_url">
                        <wrap-image :prop-image="item.image" :prop-class="getProductCategorySlug(item)"/>
                    </a>
                    <div class="product-name-mobile">
                        <a :href="item.publish_url">{{ item.title }}</a>
                        <br>
                        <span class="item-sku">SKU: {{ item.sku }}</span>
                    </div>
                </td>

                <td class="product-name" data-title="Product:">
                    <div class="product-name-desk">
                        <a :href="item.publish_url">{{ item.title }}</a>
                        <span class="item-sku">SKU: {{ item.sku }}</span>
                    </div>
                    <div class="product-variation">
                        <div class="product-variation-inner" v-if="['variable', 'huge_variations'].includes(item.type) && getProduct(item)">
                            <dl class="variation">
                                <template v-for="attribute in getProduct(item).attributes">
                                    <dt class="variation-WIDTH">{{ attribute.name }}:</dt>
                                    <dd class="variation-WIDTH">
                                        <p>{{attribute.options.find(i => i.slug === item.options[attribute.slug]).name}}</p>
                                    </dd>
                                </template>
                              <template v-if="item.extra_attribute">
                                <template v-for="(option, index) in item.extra_attribute_options">
                                  <dt class="variation-WIDTH">{{ item.extra_attribute.attribute.name  + ' ' + (parseInt(index) + 1) }}:</dt>
                                  <dd class="variation-WIDTH">
                                    <p>{{option.name}}</p>
                                  </dd>
                                </template>
                                <!-- <template v-for="(option, index) in item.extra_attribute.options">
                                  <dt class="variation-WIDTH">{{ item.extra_attribute.attribute.name  + ' ' + (parseInt(index) + 1) }}:</dt>
                                  <dd class="variation-WIDTH">
                                    <p>{{option.name}}</p>
                                  </dd>
                                </template> -->
                              </template>
                            </dl>
                        </div>
                        <dq-attributes v-if="item.type === 'dq_product'" :product="item"></dq-attributes>
                    </div>
                </td>
                <td class="product-price" data-title="Price:">
                    <span class="price-amount">
                       <bdi>{{ !item.price ? 'FREE' :priceFormatter(item.price) || 'FREE'}}</bdi>
                    </span>
                </td>

                <td class="product-units" data-title="Units:">{{ item.units || 'each' }}</td>

                <td class="product-quantity" data-title="Quantity:">
                    <div class="quantity">{{ quantityFormatter(item.quantity) }}</div>
                </td>

                <td class="product-subtotal" data-title="Subtotal:">
                    <span class="price-amount">
                        <bdi>{{ !item.price ? 'FREE' : item.price * item.quantity > 0 ? priceFormatter(item.price * item.quantity) : "FREE"  }}</bdi>
                    </span>
                </td>
            </tr>
            </tbody>
            </table>
            <table class="table shop_table order_summary_alignment_fix checkout sub_total_checkout">
            <tfoot>
            <tr class="cart-subtotal">
                <th>Subtotal</th>
                <!-- <td></td>
                <td></td>
                <td></td> -->
                <td colspan="2" data-title="Product Total">
                    <span class="price-amount amount">{{ priceFormatter($store.getters.itemsTotalPrice) }}</span>
                </td>
            </tr>
            <tr v-if="$store.getters.coupon && $store.getters.coupon.amount && $store.getters.itemsTotalPrice > 0" class="coupon-price">
                <th>
                    Coupon: {{$store.getters.coupon.code}}
                    <span><a href="javascript:" v-on:click="handleRemoveCoupon">[Remove]</a></span>
                </th>
                <td></td>
                <td></td>
                <td></td>
                <td :data-title="'Coupon: ' + $store.getters.coupon.code" style="position:relative;">
                    <span class="price-amount">-{{ $store.getters.itemsTotalPrice > $store.getters.coupon.amount ? priceFormatter($store.getters.coupon.amount) : priceFormatter($store.getters.itemsTotalPrice) }}</span>
                    <span class="mobile-remove-coupon"><a href="javascript:" v-on:click="handleRemoveCoupon">[Remove]</a></span>
                </td>
            </tr>
            <tr v-if="$store.getters.coupon && $store.getters.coupon.amount && $store.getters.itemsTotalPrice > 0" class="subtotal-with-coupon">
                <th>Subtotal w/ Coupon</th>
                <td></td>
                <td></td>
                <td></td>
                <td data-title="Subtotal w/ Coupon">
                    <span class="price-amount"> {{priceFormatter($store.getters.subTotalWithCoupon)}} </span>
                </td>
            </tr>
            <tr class="shipping-totals shipping">
                <th>Shipping</th>
                <!-- <td></td>
                <td></td> -->
                <td>{{$store.getters.shippingMethod ? $store.getters.shippingMethod.label : ""}}</td>
                <td colspan="2" data-title="Shipping">
                    <span v-if="!$store.getters.isShippingCalculated" class="shipping-text">Enter your address to view shipping options.</span>
                    <span v-if="$store.getters.isShippingCalculated" class="shipping-text">{{$store.getters.shippingIsFree ? 'FREE' : priceFormatter($store.getters.shippingPrice)}}</span>
                </td>
            </tr>
            <tr class="tax-total">
                <th>Tax</th>
                <!-- <td></td>
                <td></td>
                <td></td> -->
                <td colspan="2"  data-title="Tax">
                    <span class="price-amount amount">$ 0.00 </span>
                </td>
            </tr>


            <tr class="order-total">
                <th>Total</th>
                <!-- <td></td>
                <td></td>
                <td></td> -->
                <td colspan="2"  data-title="Total">
                    <strong><span class="price-amount amount">{{ priceFormatter($store.getters.totalPrice) }}</span></strong>
                </td>
            </tr>
            </tfoot>

        </table>
    </div>
</template>


<script>
import WrapImage from "../WrapImage";
import {mapActions} from "vuex";

export default {
    name: 'order-summary',
    components: {WrapImage},
    mounted()
    {
        this.$store.commit('SET_DATALAYER_CHECKOUT');
        this.dataLayerCheckout()
    },
    methods: {
        ...mapActions(['removeCoupon','checkCartItems','saveCart']),
        dataLayerCheckout()
        {
            this.$store.state.data_layer_begin_checkout.ecommerce.value = this.$store.getters.itemsTotalPrice;

            // for(let i=0; i<obj1Keys.length; i++) {
            //     window.dataLayer[i] = window.dataLayer[obj1Keys[i]];
            // }

            // for(let i=0; i<obj2Keys.length; i++) {
            //     window.dataLayer[i+obj1Keys.length] = this.$store.getters.checkoutDefaultDataLayer[obj2Keys[i]];
            // }

            window.dataLayer.push(this.$store.getters.checkoutDefaultDataLayer[0]);
            window.dataLayer.push(this.$store.getters.checkoutDefaultDataLayer[1]);
        },
        handleRemoveCoupon() {
            this.removeCoupon().then(res => {
                this.saveCart({page: 'checkout'})
            })
        },
        getProduct(item) {
            return this.$store.state.app.products.find(i => i.id === item.id)
        },
        getProductCategorySlug(item) {
            let products = this.$store.state.app.products;
            let product = products.length ? this.$store.state.app.products.find(i => i.id === item.id) : null

            if(product)
                return product && product.categories[0].name=='Uncategorized'? '': 'make-'+product.categories[0].slug
            else
                return ""
        }
    },
    updated()
    {
        this.checkCartItems();
    }
}
</script>
